var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$style.actions},[_c('div',[(_vm.row.ImagePath2 === '~/Images/cross.gif')?[_c('div',{domProps:{"innerHTML":_vm._s(_vm.row.timeout)}}),_vm._v(" "),_c('img',{class:_vm.$style.redCrossImage,attrs:{"src":require(`Assets/images/cross.png`)}})]:[_c('div',{domProps:{"innerHTML":_vm._s(_vm.row.timeout)}})]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }